<template>
  <v-row class="mb-6" justify="center" no-gutters>
    <v-col cols="12" style="padding:10px">
      <span>{{ errorMsg }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      errorMsg: null
    };
  },
  beforeRouteEnter(to, from, next) {
    //console.log(to)
    if (!to.query.x) {
      next(vm => {
        vm.errorMsg =
          "Sorry, you don't have the right access to reach the destination";
      });
    } else {
      next();
    }
  }
};
</script>